export const english = {
  of: 'of',
  in: 'in',
  along: 'along',
};
